import qs from 'qs'
import store from '@/store'
import router from '@/router'
import WeixinModel from '@/api/WeixinModel'
import ProfileModel from '@/api/ProfileModel'

router.beforeEach(async (to, from, next) => {
  if(process.env.NODE_ENV=='production' && window.location.href.startsWith('https://www.dushicun.cn')
      && to.meta && to.meta.authc && WeixinModel.isTimeout()){
    var redirectUri = window.location.href
    if(redirectUri.indexOf('?')>-1){
      const param = qs.parse(redirectUri.substring(redirectUri.indexOf('?')+1))
      var state = store.getters.temp
      if(state == param['state']){
        const res = await WeixinModel.getUserInfo(param["code"])
        const ret= res['data']
        if(ret && ret['code']==1){
          store.dispatch('user',ret['data'])
          if(!store.getters.mystatus) {
            const profile = await ProfileModel.buildProfile(store.getters.userId)
            if(profile['code'==1]){
              store.dispatch('mystatus',1)
              store.dispatch('mycollect',profile['collect'])
              store.dispatch('mycart',profile['cart'])
            }
          }
          next()
          return
        } else {
          return
        }
      }
      delete param["code"]
      delete param["state"]
      redirectUri = `${redirectUri.substring(0,redirectUri.indexOf('?'))}?${qs.stringify(param)}`
    }
    redirectUri = encodeURIComponent(redirectUri)
    let newState =  WeixinModel.getState()
    store.dispatch('temp',newState)
    let url = await WeixinModel.getAuthUrl(redirectUri, newState)
    window.location.href = url
  } else {
    if(window.location.href.startsWith('https://www.dushicun.cn')){
      if(to.meta && to.meta.authc && store.getters.isLogin && !store.getters.isMyInit){
        const profile = await ProfileModel.buildProfile(store.getters.userId)
        if(profile['data']['code']==1){
          store.dispatch('mystatus',1)
          store.dispatch('mycollect',profile['data']['collect'])
          store.dispatch('mycart',profile['data']['cart'])
        }
      }
    } else {
      if(to.meta && to.meta.authc && !store.getters.isMyInit){
        const profile = await ProfileModel.buildProfile(store.getters.userId)
        if(profile['data']['code']==1){
          store.dispatch('mystatus',1)
          store.dispatch('mycollect',profile['data']['collect'])
          store.dispatch('mycart',profile['data']['cart'])
        }
      }
    }
    next()
  }
})
